import React from 'react';
import OtherReports from '../components/business/OtherReports';

export const ReportsCtx = React.createContext({});

function ReportsPageProvider(props) {
  const ctx = {
  };
  return (
    <ReportsCtx.Provider value={ ctx }>
      {props.children}
    </ReportsCtx.Provider>
  );
}

function ConcentsPage() {
  return (
    <ReportsPageProvider>
      <OtherReports />
    </ReportsPageProvider>
  );
}

export default ConcentsPage;
